var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"marquee animate",class:_vm.dynamicClasses},[_c('div',{staticClass:"container"},[_c('p',{staticClass:"text"},[_vm._l((10),function(n){return [_vm._v("\n                "+_vm._s(_vm.text)+" \n               ")]})],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }